import ModalDirective from '@/components/modal-directive';
import { getSystemConfig } from '@/app/services/system';

export const useMaintenance = () => {
  const fetchMaintenanceStatus = async (feature: string) => {
    try {
      const { data } = await getSystemConfig('maintenance');
      if (!data || !data[feature]) {
        return null;
      }
      return data[feature];
    } catch (error) {
      return null;
    }
  };

  const showMaintenance = (title?: string, content?: string) => {
    ModalDirective.open({
      title: title || '系统维护中',
      content: content || '系统正在升级中，请稍后再试。',
    });
  };

  return { fetchMaintenanceStatus, showMaintenance };
};
